import { cn } from '@/lib/utils';

import { formatPendingCount } from '../utils';

/**
 * Count + purple dot shown on the agent nav surfaces (breadcrumb dropdown and
 * Overview side nav) when the inbox has pending improvements (D8). Renders
 * nothing when there is nothing pending.
 */
export const PendingImprovementsBadge = ({
  count,
  className,
}: {
  count: number;
  className?: string;
}) => {
  if (count <= 0) {
    return null;
  }

  return (
    <span className={cn('flex items-center gap-1.5', className)}>
      <span className="text-xs text-foreground-muted">{formatPendingCount(count)}</span>
      <span className="h-1.5 w-1.5 rounded-full bg-ai" />
    </span>
  );
};
